import { useFeatureFlag } from '@src/hooks/useFeatureFlag';
import { DropdownItem, IconName, type Security } from '@talos/kyoko';
import { memo, useMemo } from 'react';
import { getAvailableMultilegTypes } from '../../utils/getAvailableMultilegTypes';
import type { MultilegComboType } from '../MultilegCombo/enums';

interface CreateMultilegDropdownItemProps {
  security: Security | undefined;
  onCreateMultileg?: (multilegType: MultilegComboType) => void;
}

export const CreateMultilegDropdownItem = memo(function CreateMultilegDropdownItem({
  security,
  onCreateMultileg,
}: CreateMultilegDropdownItemProps) {
  const { enableCFDs } = useFeatureFlag();
  const availableMultilegTypes = useMemo(() => getAvailableMultilegTypes(security, enableCFDs), [security, enableCFDs]);

  if (!onCreateMultileg || availableMultilegTypes.length === 0) {
    return null;
  }

  return (
    <DropdownItem
      startIcon={IconName.Plus}
      endIcon={IconName.ChevronRight}
      submenuContent={availableMultilegTypes.map(option => (
        <DropdownItem
          key={option.type}
          data-testid={`create-multileg-option-${option.type}`}
          onClick={() => onCreateMultileg(option.type)}
        >
          {option.label}
        </DropdownItem>
      ))}
    >
      Create New Multileg
    </DropdownItem>
  );
});
